/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Satellite_ColorInputs */

const fr_help_satellite_color = /** @type {(inputs: Help_Satellite_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La couleur du satellite`)
};

const en_help_satellite_color = /** @type {(inputs: Help_Satellite_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satellite color`)
};

/**
* | output |
* | --- |
* | "Satellite color" |
*
* @param {Help_Satellite_ColorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_satellite_color = /** @type {((inputs?: Help_Satellite_ColorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Satellite_ColorInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_satellite_color(inputs)
	return en_help_satellite_color(inputs)
});